<template>
  <ul id="zhongleft">
    <li v-for="(item, index) in tableData" :key="index">
      <h4>
        <Icon size="16" style="margin-right: 4px" type="logo-buffer" />{{
          item.name
        }}
      </h4>
      <ul>
        <li
          @click="clickItem(son)"
          v-for="(son, index1) in item.cameraList"
          :key="index1"
        >
          <Icon type="md-radio-button-on" />
          {{ son.name }}
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      searchItem: {},
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-ep-server-mwm/transferSite/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    clickItem(item) {
      this.$emit("playData", item);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#zhongleft {
  padding: 20px;
  overflow: auto;
  height: 100%;
}
#zhongleft > li {
  margin-bottom: 15px;
}
#zhongleft > li > ul {
  margin-left: 0px;
}
#zhongleft > li > ul > li {
  margin-top: 6px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/zhongzz/zhzz/zzleft.vue